import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { FC, JSX, PropsWithChildren } from 'react';

interface AccordionItemProps {
  title: JSX.Element;
  body: JSX.Element;
}

const AccordionItem: FC<PropsWithChildren<AccordionItemProps>> = ({ title, body }) => (
  <Accordion
    disableGutters
    sx={{
      border: 0,
      '&:not(:last-child)': {
        borderBottom: 0,
      },
      '&:before': {
        display: 'none',
      },
    }}
    elevation={0}
  >
    <AccordionSummary
      expandIcon={<ExpandMoreIcon />}
      aria-controls="panel1a-content"
      id="panel1a-header"
    >
      {title}
    </AccordionSummary>
    <AccordionDetails>{body}</AccordionDetails>
  </Accordion>
);

export default AccordionItem;
